// export const API = "http://localhost:8000";
export const API = "https://beameri-api.onrender.com";
